// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  ministry:"ក្រសួងសេដ្ឋកិច្ច និងហិរញ្ញវត្ថុ",
  baseUrl: 'https://edoc-api.mef.gov.kh/',
  default_doc_type_id: '5be39bddb7eb68078652121f',
  default_from_to_id: '5ea0ff5a0086940a8cab377c',
  cabinet_group_id: '606b3184a3451c22e8fbb45c',
  scanner_key:''
};

// export const environment = {
//   production: false,
//   ministry: 'ក្រសួងសេដ្ឋកិច្ច និងហិរញ្ញវត្ថុ',
//   baseUrl: 'http://localhost:8080/',
//   default_doc_type_id: '5be39bddb7eb68078652121f',
//   default_from_to_id: '5f0fc6117ef0d6671abcd66b',
//   scanner_key: 't0152KQMAAC01euAvODM8WHrgQ5IfiKMRPsrbFqUYwZiCg9VNEGD8XJxHGLQ7f4DmwXOLDjM9f/6UhdEtlSTCiRSthj22qZ42pGPDCAyKCz062ZUaw6d5u5FqcNPnb3zWnfng/Oj0aQxPGBkb30/fhJl/O+Q4c2t4wsjYhJkbE+9ZzaRdQFvNTD3DE0bGpma+GqZUVLN+AcTjnn4=',
//   cabinet_group_id: '60657b1d50a180436c0812ff'
// };
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
